import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CustomUserState, StateWithCustomUser } from '../user-state';
import { getCustomUserState } from './feature.selector';

export const getSubmitAuthCodeState: MemoizedSelector<
  StateWithCustomUser,
  StateUtils.LoaderState<string>
> = createSelector(getCustomUserState, (state: CustomUserState) => state.submitAuthCode);

export const getSubmitAuthCodeValue: MemoizedSelector<StateWithCustomUser, string> = createSelector(
  getSubmitAuthCodeState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderValueSelector(state),
);

export const getSubmitAuthCodeLoading: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getSubmitAuthCodeState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderLoadingSelector(state),
);

export const getSubmitAuthCodeError: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getSubmitAuthCodeState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderErrorSelector(state),
);

export const getSubmitAuthCodeSuccess: MemoizedSelector<StateWithCustomUser, boolean> = createSelector(
  getSubmitAuthCodeState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderSuccessSelector(state),
);
